import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-2xl">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
        Privacy Policy
      </h1>
      <p className="text-gray-600 mb-4">
        This Privacy Policy ("Policy") applies to fundraisewithmamfam.com and
        The Make a Memory Family ("Company") and governs data collection and
        usage. By using our website, you consent to the data practices described
        below.
      </p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Collection of Your Personal Information
        </h2>
        <ul className="list-disc pl-5 text-gray-600">
          <li>First and last name</li>
          <li>Mailing address</li>
          <li>Email address</li>
          <li>Phone number</li>
        </ul>
        <p className="text-gray-600 mt-2">
          If you purchase the Company's products and services, we collect
          billing and credit card information. This information is used to
          complete the purchase transaction
        </p>
      </section>

      <p>
        We do not collect any personal information about you unless you
        voluntarily provide it to us. However, you may be required to provide
        certain personal information to us when you elect to use certain
        products or services. These may include: (a) registering for an account;
        (b) entering a sweepstakes or contest sponsored by us or one of our
        partners; (c) signing up for special offers from selected third parties;
        (d) sending us an email message; (e) submitting your credit card or
        other payment information when ordering and purchasing products and
        services. To wit, we will use your information for, but not limited to,
        communicating with you in relation to services and/or products you have
        requested from us. We also may gather additional personal or
        non-personal information in the future.
      </p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Use of Your Personal Information
        </h2>
        <ul className="list-disc pl-5 text-gray-600">
          <li>to operate and deliver the services you have requested</li>
          <li>
            to provide you with information, products, or services that you
            request from us
          </li>
          <li>to provide you with notices about your account </li>
          <li>
            to carry out the Company's obligations and enforce our rights
            arising from any contracts entered between you and us, including for
            billing and collection
          </li>
          <li>
            to notify you about changes to our fundraisewithmamfam.com or any
            products or services we offer or provide through it
          </li>
          <li>
            in any other way we may describe when you provide the information
          </li>
          <li>for any other purpose with your consent.</li>
        </ul>
        <p>
          The Company may also use your personally identifiable information to
          inform you of other products or services available from the Company
          and its affiliates.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Sharing with Third Parties
        </h2>
        <p>
          The Company does not sell, rent, or lease its customer lists to third
          parties.
        </p>
        <p className="text-gray-600">
          The Company may share data with trusted partners to help perform
          statistical analysis, send you email or postal mail, provide customer
          support, or arrange for deliveries. All such third parties are
          prohibited from using your personal information except to provide
          these services tothe Company, and they are required to maintain the
          confidentiality of your information.
        </p>
        <p className="text-gray-600">
          The Company may disclose your personal information, without notice, if
          required to do so by law or in the good faith belief that such action
          is necessary to: (a) conform to the edicts of the law or comply with
          legal process served on the Company or the site; (b) protect and
          defend the rights or property of the Company; and/or (c) act under
          exigent circumstances to protect the personal safety of users of the
          Company, or the public.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Automatically Collected Information
        </h2>
        <p className="text-gray-600">
          The Company may automatically collect information about your computer
          hardware and software. This information can include your IP address,
          browser type, domain names, access times, and referring website
          addresses. This information is used for the operation of the service,
          to maintain quality of the service, and to provide general statistics
          regarding the use of the Company's website.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">Use of Cookies</h2>
        <p className="text-gray-600">
          The Company's website may use "cookies" to help you personalize your
          online experience. A cookie is a text file that is placed on your hard
          disk by a web page server. Cookies cannot be used to run programs or
          deliver viruses to your computer. Cookies are uniquely assigned to
          you, and can only be read by a web server in the domain that issued
          the cookie to you
        </p>
        <p className="text-gray-600">
          One of the primary purposes of cookies is to provide a convenience
          feature to save you time. The purpose of a cookie is to tell the web
          server that you have returned to a specific page. For example, if you
          personalize the Company's pages, or register with Company's site or
          services, a cookie helps the Company to recall your specific
          information on subsequent visits. This simplifies the process of
          recording your personal information, such as billing addresses,
          shipping addresses, and so on. When you return to the same website,
          the information you previously provided can be retrieved, so you can
          easily use the Company's features that you customized.
        </p>
        <p className="text-gray-600">
          You have the ability to accept or decline cookies. Most web browsers
          automatically accept cookies, but you can usually modify your browser
          settings to decline cookies if you prefer. If you choose to decline
          cookies, you may not be able to fully experience the interactive
          features of the Company's services or websites you visit.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">Links</h2>
        <p className="text-gray-600">
          This website contains links to other sites. Please be aware that we
          are not responsible for the content or privacy practices of such other
          sites. We encourage our users to be aware when they leave our site and
          to read the privacy statements of any other site that collects
          personally identifiable information.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Security of your Personal Information
        </h2>
        <p className="text-gray-600">
          The Company secures your personal information from unauthorized
          access, use, or disclosure. The Company uses the following methods for
          this purpose:
        </p>
        <li>SSL Protocol</li>
        <p className="text-gray-600">
          When personal information (such as a credit card number) is
          transmitted to other websites, it is protected through the use of
          encryption, such as the Secure Sockets Layer (SSL) protocol.
        </p>
        <p className="text-gray-600">
          We strive to take appropriate security measures to protect against
          unauthorized access to or alteration of your personal information.
          Unfortunately, no data transmission over the Internet or any wireless
          network can be guaranteed to be 100% secure. As a result, while we
          strive to protect your personal information, you acknowledge that: (a)
          there are security and privacy limitations inherent to the Internet
          that are beyond our control; and (b) the security, integrity, and
          privacy of any and all information and data exchanged between you and
          us through this site cannot be guaranteed.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Right to Deletion
        </h2>
        <p className="text-gray-600">
          Subject to certain exceptions set out below, on receipt of a
          verifiable request from you, we will:
        </p>
        <li> Delete your personal information from our records; and</li>
        <li>
          Direct any service providers to delete your personal information from
          their records.
        </li>
        <p className="text-gray-600">
          Please note that we may not be able to comply with requests to delete
          your personal information if it is necessary to:
        </p>
        <li>
          Complete the transaction for which the personal information was
          collected, fulfill the terms of a written warranty or product recall
          conducted in accordance with federal law, and provide a good or
          service requested by you, or reasonably anticipated within the context
          of our ongoing business relationship with you, or otherwise perform a
          contract between you and us;
        </li>
        <li>
          Detect security incidents, protect against malicious, deceptive,
          fraudulent, or illegal activity; or prosecute those responsible for
          that activity;
        </li>
        <li>
          Debug to identify and repair errors that impair existing intended
          functionality;
        </li>
        <li>
          Exercise free speech, ensure the right of another consumer to exercise
          his or her right of free speech, or exercise another right provided
          for by law;
        </li>
        <li>
          Comply with the California Electronic Communications Privacy Act;
        </li>
        <li>
          Engage in public or peer-reviewed scientific, historical, or
          statistical research in the public interest that adheres to all other
          applicable ethics and privacy laws, when our deletion of the
          information is likely to render impossible or seriously impair the
          achievement of such research, provided we have obtained your informed
          consent;
        </li>
        <li>
          Enable solely internal uses that are reasonably aligned with your
          expectations based on your relationship with us;
        </li>
        <li>Comply with an existing legal obligation; or</li>
        <li>
          Otherwise use your personal information, internally, in a lawful
          manner that is compatible with the context in which you provided the
          information.
        </li>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Children Under Thirteen
        </h2>
        <p className="text-gray-600">
          The Company does not knowingly collect personally identifiable
          information from children under the age of 13. If you are under the
          age of 13, you must ask your parent or guardian for permission to use
          this website.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Email Communications
        </h2>
        <p className="text-gray-600">
          From time to time, the Company may contact you via email for the
          purpose of providing announcements, promotional offers, alerts,
          confirmations, surveys, and/or other general communication.
        </p>
        <p className="text-gray-600">
          If you would like to stop receiving marketing or promotional
          communications via email from the Company, you may opt out of such
          communications by clicking the unsubscribe button at the bottom of the
          email.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          External Data Storage Sites
        </h2>
        <p className="text-gray-600">
          We may store your data on servers provided by third-party hosting
          vendors with whom we have contracted.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Changes to This Statement
        </h2>
        <p className="text-gray-600">
          The Company reserves the right to change this Policy from time to
          time. For example, when there are changes in our services, changes in
          our data protection practices, or changes in the law. When changes to
          this Policy are significant, we will inform you. You may receive a
          notice by sending an email to the primary email address specified in
          your account, by placing a prominent notice on our The Make a Memory
          Family, and/or by updating any privacy information. Your continued use
          of the website and/or services available after such modifications will
          constitute your: (a) acknowledgment of the modified Policy; and (b)
          agreement to abide and be bound by that Policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-700">
          Contact Information
        </h2>
        <p className="text-gray-600">For inquiries, contact us at:</p>
        <p className="text-gray-600">
          <strong>Email:</strong> help@themakeamemoryfamily.com
        </p>
        <p className="text-gray-600">
          <strong>Phone:</strong> 888-508-0808
        </p>
        <p className="text-gray-600">
          <strong>Address:</strong> 1781 N Capital St, Corona, California 92880
        </p>
        <p className="text-gray-600">Effective as of February 11, 2025</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
